import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import { apiClient } from '../services/api';

const PLANS = {
  ClusStart: 'Cluster Starter: 1 publisher + 2 subscribers, 2 vCPU / 8 GB each',
  ClusPro: 'Cluster Professional: 1 publisher + 3 subscribers, 4 vCPU / 16 GB each',
  ClusBiz: 'Cluster Business: 1 publisher + 5 subscribers, 8 vCPU / 32 GB each',
  ClusEnt: 'Cluster Enterprise: 1 publisher + 5 subscribers, 16 vCPU / 64 GB each',
  ClusUltra: 'Cluster Enterprise Ultra: 1 publisher + 5 subscribers, 32 vCPU / 120 GB each',
  ClusMax: 'Cluster Enterprise Max: 1 publisher + 5 subscribers, 32 vCPU / 244 GB each'
};

function NewCluster() {
  const { activeCustomerId } = useContext(AuthContext);
  const navigate = useNavigate();
  const [agreements, setAgreements] = useState([]);
  const [form, setForm] = useState({ project_name: '', agreement_id: '', region: 'us-east-1', writer_cidrs: '', reader_cidrs: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      if (!activeCustomerId) return;
      try {
        const response = await apiClient.get(`/customers/${activeCustomerId}`);
        const eligible = (response.data?.marketplace_agreements || []).filter((agreement) => (
          String(agreement.status).toLowerCase() === 'active' && PLANS[agreement.marketplace_dimension] && agreement.agreement_id
        ));
        setAgreements(eligible);
        if (eligible.length === 1) setForm((current) => ({ ...current, agreement_id: eligible[0].agreement_id }));
      } catch (loadError) {
        setError(loadError.response?.data?.error || 'Unable to check Marketplace cluster eligibility.');
      }
    };
    load();
  }, [activeCustomerId]);

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true); setError('');
    try {
      const response = await apiClient.post('/clusters', {
        ...form,
        customer_id: activeCustomerId,
        writer_cidrs: form.writer_cidrs.split(',').map((item) => item.trim()).filter(Boolean),
        reader_cidrs: form.reader_cidrs.split(',').map((item) => item.trim()).filter(Boolean)
      });
      navigate(`/clusters/${response.data.cluster_id}`);
    } catch (submitError) {
      setError(submitError.response?.data?.error || submitError.message || 'Cluster provisioning could not be started.');
    } finally { setLoading(false); }
  };

  return (
    <div>
      <div className="page-header"><div><Link to="/clusters">← Back to RDF Clusters</Link><h1>Create RDF Cluster</h1></div></div>
      <div className="card">
        <p>The cluster shape is fixed by the Marketplace agreement. Commercial Virtuoso is included; node count and task sizing are seller controlled.</p>
        {error && <div className="alert alert-error">{error}</div>}
        {agreements.length === 0 ? <div className="alert alert-warning">No active RDF Cluster agreement is available for this customer.</div> : (
          <form onSubmit={submit}>
            <div className="form-group"><label htmlFor="cluster-name">Cluster Name</label><input id="cluster-name" required pattern="[a-z0-9-]+" value={form.project_name} onChange={(event) => setForm({ ...form, project_name: event.target.value })} placeholder="my-rdf-cluster" /></div>
            <div className="form-group"><label htmlFor="cluster-agreement">Marketplace Agreement</label><select id="cluster-agreement" required value={form.agreement_id} onChange={(event) => setForm({ ...form, agreement_id: event.target.value })}><option value="">Select an agreement</option>{agreements.map((agreement) => <option key={agreement.agreement_id} value={agreement.agreement_id}>{PLANS[agreement.marketplace_dimension]}</option>)}</select></div>
            <div className="form-group"><label htmlFor="writer-cidrs">Writer CIDRs</label><input id="writer-cidrs" required value={form.writer_cidrs} onChange={(event) => setForm({ ...form, writer_cidrs: event.target.value })} placeholder="203.0.113.45/32" /><p className="help-text">Restricted IPv4 ranges allowed to write to the publisher.</p></div>
            <div className="form-group"><label htmlFor="reader-cidrs">Reader CIDRs</label><input id="reader-cidrs" required value={form.reader_cidrs} onChange={(event) => setForm({ ...form, reader_cidrs: event.target.value })} placeholder="203.0.113.45/32" /><p className="help-text">Restricted IPv4 ranges allowed to read from subscriber endpoints.</p></div>
            <button className="btn btn-primary" disabled={loading}>{loading ? 'Starting...' : 'Create RDF Cluster'}</button>
          </form>
        )}
      </div>
    </div>
  );
}

export default NewCluster;
